import { createTypedHooks } from 'easy-peasy'
import { model } from 'src/state'

const typedHooks = createTypedHooks<typeof model>()

export const useStore = typedHooks.useStore
export const useStoreState = typedHooks.useStoreState
